import React, {FC} from "react"

import ProfilePic from "@irati/ui/src/ProfilePicture"
import {User} from "@irati/types"

import {ProfileContainer, OuterContainer, ProfileBorder} from "./styled"

interface Props {
  user: User,
  size?: number,
  border?: number
}

export const DEFAULT_SIZE = 150
export const DEFAULT_BORDER_SIZE = 10

const Profile: FC<Props> = ({user, size, border}) => {
  return (
    <ProfileContainer size={size}>
      <OuterContainer size={size}>
        <ProfileBorder size={size} border={border}>
          <ProfilePic user={user} size={`${size - border}px`} />
        </ProfileBorder>
      </OuterContainer>
    </ProfileContainer>
  )
}

Profile.defaultProps = {
  size: DEFAULT_SIZE,
  border: DEFAULT_BORDER_SIZE
}

export default Profile
